import {
  FuelType,
  Vehicle,
  VehicleCategory,
  VehicleType,
} from "@b2bportal/ground-api";

export const VehicleClass = {
  EV: "EV",
  MiniCompact: "MiniCompact",
  Standard: "Standard",
  Fullsize: "Fullsize",
  PremiumLuxury: "PremiumLuxury",
  MinivanWagon: "MinivanWagon",
  SUVSpecialty: "SUVSpecialty",
  Special: "Special",
} as const;
export type VehicleClass = keyof typeof VehicleClass;

export const getVehicleClassFromCategory = (vehicle: Vehicle) => {
  if (vehicle.fuelType === FuelType.Electric) {
    return VehicleClass.EV;
  }
  switch (vehicle.category) {
    case VehicleCategory.Mini:
    case VehicleCategory.MiniElite:
    case VehicleCategory.Economy:
    case VehicleCategory.EconomyElite:
    case VehicleCategory.Compact:
    case VehicleCategory.CompactElite:
      return VehicleClass.MiniCompact;

    case VehicleCategory.Intermediate:
    case VehicleCategory.IntermediateElite:
    case VehicleCategory.Standard:
    case VehicleCategory.StandardElite:
      return VehicleClass.Standard;

    case VehicleCategory.Fullsize:
    case VehicleCategory.FullsizeElite:
      return VehicleClass.Fullsize;

    case VehicleCategory.Premium:
    case VehicleCategory.PremiumElite:
    case VehicleCategory.Luxury:
    case VehicleCategory.LuxuryElite:
      return VehicleClass.PremiumLuxury;

    case VehicleCategory.Oversize:
      return VehicleClass.MinivanWagon;

    case VehicleCategory.Special:
      return VehicleClass.Special;

    default:
    // try using vehicle type
  }

  switch (vehicle.vehicleType) {
    case VehicleType.WagonEstate:
    case VehicleType.PassengerVan:
    case VehicleType.PickUpSingleExtendedCar:
    case VehicleType.PickUpDoubleCab:
    case VehicleType.Crossover:
    case VehicleType.CommercialVanTruck:
      return VehicleClass.MinivanWagon;

    case VehicleType.SUV:
    case VehicleType.OpenAirAllTerrain:
      return VehicleClass.SUVSpecialty;

    case VehicleType.SpecialCar:
      return VehicleClass.Special;

    case VehicleType.SportsCar:
    case VehicleType.Convertible:
      return VehicleClass.PremiumLuxury;

    default:
      // TODO: log datadog error to track any unexpected vehicle class
      return VehicleClass.Standard;
  }
};

export const getVehicleClassLabel = (vehicleClass: VehicleClass) =>
  ({
    [VehicleClass.EV]: "EV",
    [VehicleClass.MiniCompact]: "Mini/Compact",
    [VehicleClass.Standard]: "Standard",
    [VehicleClass.Fullsize]: "Fullsize",
    [VehicleClass.PremiumLuxury]: "Premium/Luxury",
    [VehicleClass.MinivanWagon]: "Minivan/Wagon",
    [VehicleClass.SUVSpecialty]: "SUV/Specialty",
    [VehicleClass.Special]: "Supplier's Choice",
  }[vehicleClass]);

export const getVehicleClassLabelFromVehicleCategory = (vehicle: Vehicle) => {
  const vehicleClass = getVehicleClassFromCategory(vehicle);
  return getVehicleClassLabel(vehicleClass);
};
